export default __webpack_public_path__ + "static/media/thermometer-outline.d1e20d6e.svg";